import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { P } from '../../config/permissionCodes';

/**
 * Smart redirect for /finance route.
 * Checks report screen permissions in order and redirects to the first accessible one.
 */
const reportScreens = [
  { permission: P.REPORTS.SALES.SCREEN,      path: '/finance/reports/daily-sales' },
  { permission: P.REPORTS.FINANCIAL.SCREEN,   path: '/finance/reports/payment-analysis' },
  { permission: P.REPORTS.CUSTOMERS.SCREEN,   path: '/finance/reports/customer-insights' },
  { permission: P.REPORTS.OPERATIONS.SCREEN,  path: '/finance/reports/waiter-performance' },
  { permission: P.REPORTS.INVENTORY.SCREEN,   path: '/finance/reports/stock-status' },
];

export default function ReportsLandingRedirect() {
  const { hasPermission } = useAuth();

  for (const screen of reportScreens) {
    if (hasPermission(screen.permission)) {
      return <Navigate to={screen.path} replace />;
    }
  }

  // No accessible reports — show access denied
  return (
    <div className="flex items-center justify-center h-full text-center px-6 py-20">
      <div>
        <p className="text-lg font-semibold text-gray-700">Access Denied</p>
        <p className="text-sm text-gray-500 mt-1">You don't have permission to view any reports.</p>
      </div>
    </div>
  );
}
